export const SUCCESS_MESSAGE = 'success'
export const FAIL_MESSAGE = 'fail'
export const ERROR_MESSAGE = 'error'
export const VALIDATE_FAIL = '预约时间用户已经有约'
export const VALIDATE_SUCCESS = '验证通过'
export const FAIL_CODE = 'FAILURE-0001'
export const FAIL_CODE_NO_CAR = 'FAILURE-0002'
export const FAIL_CODE_REPEAT_PHONE_NUMBER = 'FAILURE-0003'
export const REPEAT_VERIFICATION_CODE = 'FAILURE-0004'
export const REPEAT_CAR_NUMBER = 'FAILURE-0005'



// WEBPACK FOOTER //
// ./src/constants/ReturnMessageConstants.js